<script>
  export let content = '';
  export let idUnico = 'dicademidia';

  content = content.replaceAll('et al.', '<i>et al.</i>');
</script>

<div class="container">
  <div class="icon-wrapper">
    <svg width="44" height="38" viewBox="0 0 44 38" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask
        id="mask_{idUnico}"
        style="mask-type:luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="44"
        height="38"
      >
        <path
          d="M17.8978 0.23C6.07778 1.77 -0.702222 9.21 0.0577777 15C1.36778 25.05 11.7178 23.35 15.9678 31.58C21.1178 41.54 46.3378 41.03 43.3878 18.5C41.7978 6.32 31.9678 0 21.3878 0C20.2278 0 19.0578 0.0799995 17.8878 0.23"
          fill="white"
        />
      </mask>
      <g mask="url(#mask_{idUnico})">
        <path d="M46.3478 0H-0.69223V41.54H46.3478V0Z" fill="url(#grad_{idUnico})" />
      </g>
      <path
        d="M31.4378 12.15H23.5578C23.0878 12.15 22.7078 11.77 22.7078 11.31C22.7078 10.85 23.0878 10.46 23.5578 10.46H31.4378C31.9078 10.46 32.2878 10.84 32.2878 11.31C32.2878 11.78 31.9078 12.15 31.4378 12.15ZM31.4378 18.14H23.5578C23.0878 18.14 22.7078 17.76 22.7078 17.29C22.7078 16.82 23.0878 16.45 23.5578 16.45H31.4378C31.9078 16.45 32.2878 16.83 32.2878 17.29C32.2878 17.75 31.9078 18.14 31.4378 18.14ZM31.4378 24.13H23.5578C23.0878 24.13 22.7078 23.75 22.7078 23.28C22.7078 22.81 23.0878 22.44 23.5578 22.44H31.4378C31.9078 22.44 32.2878 22.82 32.2878 23.28C32.2878 23.74 31.9078 24.13 31.4378 24.13ZM21.1578 10.26L20.6378 10.77C20.5578 10.84 20.5278 10.95 20.5478 11.06L20.6678 11.78C20.7178 12.04 20.4378 12.25 20.1978 12.12L19.5578 11.78C19.4678 11.73 19.3478 11.73 19.2578 11.78L18.6178 12.12C18.3778 12.24 18.0978 12.04 18.1478 11.78L18.2678 11.06C18.2878 10.96 18.2478 10.85 18.1778 10.77L17.6578 10.26C17.4678 10.07 17.5678 9.75001 17.8378 9.71001L18.5578 9.61002C18.6678 9.60002 18.7578 9.53002 18.7978 9.43002L19.1178 8.78001C19.2378 8.54001 19.5778 8.54001 19.6978 8.78001L20.0178 9.43002C20.0678 9.52002 20.1578 9.59002 20.2578 9.61002L20.9778 9.71001C21.2378 9.75001 21.3478 10.07 21.1578 10.26ZM21.1578 16.25L20.6378 16.76C20.5578 16.83 20.5278 16.94 20.5478 17.05L20.6678 17.77C20.7178 18.03 20.4378 18.24 20.1978 18.11L19.5578 17.77C19.4678 17.72 19.3478 17.72 19.2578 17.77L18.6178 18.11C18.3778 18.23 18.0978 18.03 18.1478 17.77L18.2678 17.05C18.2878 16.95 18.2478 16.84 18.1778 16.76L17.6578 16.25C17.4678 16.06 17.5678 15.74 17.8378 15.7L18.5578 15.6C18.6678 15.58 18.7578 15.52 18.7978 15.42L19.1178 14.77C19.2378 14.53 19.5778 14.53 19.6978 14.77L20.0178 15.42C20.0678 15.51 20.1578 15.58 20.2578 15.6L20.9778 15.7C21.2378 15.74 21.3478 16.06 21.1578 16.25ZM21.1578 22.24L20.6378 22.75C20.5578 22.83 20.5278 22.93 20.5478 23.04L20.6678 23.76C20.7178 24.02 20.4378 24.23 20.1978 24.1L19.5578 23.76C19.4678 23.71 19.3478 23.71 19.2578 23.76L18.6178 24.1C18.3778 24.23 18.0978 24.02 18.1478 23.76L18.2678 23.04C18.2878 22.93 18.2478 22.83 18.1778 22.75L17.6578 22.24C17.4678 22.05 17.5678 21.73 17.8378 21.69L18.5578 21.59C18.6678 21.58 18.7578 21.51 18.7978 21.41L19.1178 20.76C19.2378 20.52 19.5778 20.52 19.6978 20.76L20.0178 21.41C20.0678 21.5 20.1578 21.57 20.2578 21.59L20.9778 21.69C21.2378 21.73 21.3478 22.05 21.1578 22.24ZM32.4178 6.11002H17.0778C15.6478 6.11002 14.4978 7.27002 14.4978 8.69002V25.16C14.4978 26.59 15.6578 27.74 17.0778 27.74H32.4178C33.8478 27.74 34.9978 26.58 34.9978 25.16V8.69002C34.9978 7.26002 33.8378 6.11002 32.4178 6.11002Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="grad_{idUnico}"
          x1="0.92707"
          y1="19.3682"
          x2="44.5571"
          y2="19.3682"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#B56F4E" />
          <stop offset="1" stop-color="#E1DE21" />
        </linearGradient>
      </defs>
    </svg>
  </div>
  <div class="titulo">
    <h2><b>DICAS</b> DE MÍDIA</h2>
  </div>
  <div class="box-texto">
    {@html content}
  </div>
</div>

<style>
  .container {
    --Principais-Roxo-azul: #8421e9;
    --transparentes-roxo-10: rgba(132, 33, 233, 0.1);
    --cor-primaria: #b62ca2;
    --cor-secundaria: #33cfb9;

    position: relative;
    padding-top: 16px;
  }

  .icon-wrapper {
    position: absolute;
    top: 5px;
    left: -30px;
    z-index: 10;
  }

  .icon-wrapper svg {
    width: 75px;
    height: auto;
    filter: drop-shadow(0 0 3px #00000044);
  }

  .box-texto {
    width: 100%;
    height: auto;

    color: #000000;
    font-family: var(--FONT_LORA);
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 26px;

    border-radius: 0 35px 35px 35px;
    padding: 25px 30px 25px 29px;
    white-space: pre-wrap;
    word-break: break-word;

    border: 2px solid #e1de21;
    background-color: #f9f8d3;

    background-origin: border-box;
    background-clip: padding-box, border-box;
  }
  .titulo {
    width: fit-content;
    background: linear-gradient(90deg, #b6724d, #cdab35, #e0db22);
    padding: 6px 15px 5px 60px;
    border-radius: 12.7px 20px 20px 0px;
  }

  .titulo h2 {
    color: var(--Principais-Branco, #fff);
    font-family: var(--FONT_ARCHI);
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    text-transform: uppercase;
    margin-bottom: 0em;
  }

  @media (max-width: 800px) {
    .icon-wrapper {
      top: 5px;
      transform: translateY(0px);
      left: 10px;
    }

    .icon-wrapper svg {
      width: 60px;
      height: unset;
      filter: drop-shadow(0 0 3px #00000044);
    }
    .titulo {
      padding: 7px 25px 7px 65px;
      border-radius: 24px 20px 20px 0px;
      top: 18px;
      position: relative;
    }
    .box-texto {
      padding: 20px 20px 15px 20px;
      margin-top: 18px;
    }
  }
</style>
